import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(public router: Router) {}

  canActivate() {
    if (AuthService.loggedIn()) {
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }
}
